import React from 'react'
import { Body, Box } from '../layout'

export const Bullets = ({ items, size, tickColor = 'black', backgroundColor = 'white' }) => (
  <Box column gap={8}>
    {items.map((item, i) =>
      <Box key={i} gap={10}>
        <Box justifyContent="center" alignItems="center">
          <Bullet tickColor={tickColor} backgroundColor={backgroundColor} />
        </Box>
        <Body size={size}>{item}</Body>
      </Box>
    )}
  </Box>
)

const Bullet = ({ tickColor, backgroundColor }) => (
  <Box minWidth={24} minHeight={25}>
    <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect y="0.573242" width="24" height="24" rx="12" fill={backgroundColor}/>
      <path d="M9.99997 16.1593L6.70697 12.8663L5.29297 14.2803L9.99997 18.9873L19.707 9.28027L18.293 7.86627L9.99997 16.1593Z" fill={tickColor}/>
    </svg>
  </Box>
)